import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface StepState {
  currentStep: number;
}
const initialState: StepState = {
  currentStep: 1,
};
export const jointApplication = createSlice({
  name: "jointApplication",
  initialState,
  reducers: {
    nextStep: (state) => {
      if (state.currentStep < 11) state.currentStep += 1;
    },
    prevStep: (state) => {
      if (state.currentStep > 1) state.currentStep -= 1;
    },
    setStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
  },
});

export const { nextStep, prevStep, setStep } = jointApplication.actions;

export default jointApplication.reducer;
